import React, { PureComponent } from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import "./registration.css";
import logo from "../../../img/Conga_Wordmark_Purple400Small.svg";
import Input from "@salesforce/design-system-react/components/input";
import Button from "@salesforce/design-system-react/components/button";
import Spinner from "@salesforce/design-system-react/components/spinner";
import Alert from "@salesforce/design-system-react/components/alert";
import AlertContainer from "@salesforce/design-system-react/components/alert/container";
import Icon from "@salesforce/design-system-react/components/icon";
import IconSettings from "@salesforce/design-system-react/components/icon-settings";
import Checkbox from "@salesforce/design-system-react/components/checkbox";
import Toast from "@salesforce/design-system-react/components/toast";
import ToastContainer from "@salesforce/design-system-react/components/toast/container";
import Modal from "@salesforce/design-system-react/components/modal";
import Combobox from "@salesforce/design-system-react/components/combobox";
import comboboxFilterAndLimit from "@salesforce/design-system-react/components/combobox/filter";
import Tooltip from "@salesforce/design-system-react/components/tooltip";

import {
  removeOrgIdCheksum,
  dateFormatter,
  getApiBaseURL,
  logoutAndRedirectToURL,
  doLogout,
  logout,
  isLoggedIn,
  isEmpty,
  getOrgId,
  getAccessToken,
  AccessControlEnum,
  handleAPIErrors,
} from "../../common";
import { PU_RELEATIVE_PATH, SF_ICON_PATH } from "../../../config";
import { Grid, Typography } from "@material-ui/core";
import api from "../../../api";
import { Dropdown } from "react-bootstrap";

class Registration extends PureComponent<{}, any> {
  constructor(props) {
    super(props);
    this.state = {
      toastHeaderInfo: null,
      organization: {},
      isLoading: true,
      showToast: false,
      isAccessCtrlModalOpen: false,
      isEarlyFeedbackModalOpen: false,
      packageAccessCtrl: [],
      changeBtnTextToUpdate: false,
      isHeadInstallForAdmin: false,
      isHeadInstallForAllUsers: false,
      isHeadInstallForCustomProfiles: false,
      displayDependentPkgFootnotes: false,
      accountsWithIcon: {},
      inputValue: {},
      selection: {},
      CheckboxInputError: {},
      disableUpdateBtn: false,
    };
  }

  async componentDidMount() {
    try {
      this.getInitData();
    } catch (e) {
      console.log("some error", e, e.message);
    }
  }

  openToast(message) {
    this.setState({ toastHeaderInfo: message });
    this.setState({ showToast: true });
  }

  //Using Auth Code authenticate the connected app to get access token.
  getOrgInformation(orgId) {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getAccessToken(),
      },
    };

    api.get(getApiBaseURL() + "/CustomerPreference/" + orgId, requestOptions)
      // .then(handleAPIErrors)
      .then((response) => response.data)
      .then((response) => {
        // response.orgId = removeOrgIdCheksum(response.orgId);
        if (response.isSandbox) {
          response.isSandbox = "Sandbox";
          localStorage.setItem("isSandbox", "Yes");
        } else {
          response.isSandbox = "Production";
        }
        if (isEmpty(response.id)) {
          response.enableExternalDependentPackageInstallation = true;
        } else {
          this.setState({ changeBtnTextToUpdate: true });
          this.setState({ disableUpdateBtn: true });
        }
        this.setState({ organization: response });
        this.setState({ isLoading: false });
        localStorage.setItem("org_id", response.orgId);
        localStorage.setItem("instanceURL", response.instanceURL);
      });
  }

  getInitData = async () => {
    let orgID = getOrgId();

    if (!isEmpty(orgID) && isLoggedIn()) {
      this.getOrgInformation(orgID);
    } else {
      console.log("Log out");
      doLogout();
      window.location.href = PU_RELEATIVE_PATH + "welcome";
    }
  };

  handleClick = () => {
    window.location.href = PU_RELEATIVE_PATH + "release-detail";
  };

  openAccessControlModal = () => {
    this.toggleAccessCtrlModalOpen();
    this.setState({ isLoading: true });
    let orgID = getOrgId();
    let includeThirdPartyPackages = false;
    this.setState({ packageAccessCtrl: [] });

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getAccessToken(),
      },
    };
    api.get(
      getApiBaseURL() +
      "/CustomerPreference/GetPackageAccessControlInfo/" +
      orgID +
      "/" +
      includeThirdPartyPackages,
      requestOptions
    )
      // .then(handleAPIErrors)
      .then((response) => response.data)
      .then((response) => {
        if (response.length > 0) {
          let comboSelectionObj = {};
          let comboInputObj = {};
          let usertypesWithIcon = {};
          let chkbxErr = {};

          for (var i = 0; i < response.length; i++) {

            if (!response[i].isInstalledPackage) {
              this.setState({ displayDependentPkgFootnotes: true });
            }

            chkbxErr[response[i].packageId] = false;

            comboSelectionObj[response[i].packageId] = response[
              i
            ].userProfileList
              .filter(function (x) {
                return response[i].customProfileIds.includes(x.id);
              })
              .map((x) => ({
                value: x.id,
                label: x.name,
                disabled: x.name === "System Administrator",
                type: x.name === "System Administrator" ? "user_role" : "user",
                ...{
                  icon: (
                    <Icon
                      assistiveText={{ label: "Account" }}
                      category="standard"
                      name={
                        x.name === "System Administrator" ? "user_role" : "user"
                      }
                    />
                  ),
                },
              }));

            comboInputObj[response[i].packageId] = "";

            usertypesWithIcon[response[i].packageId] = response[i].userProfileList.map((x) => ({
              id: x.id,
              value: x.id,
              label: x.name,
              disabled: x.name === "System Administrator",
              type: x.name === "System Administrator" ? "user_role" : "user",
              ...{
                icon: (
                  <Icon
                    assistiveText={{ label: "Account" }}
                    category="standard"
                    name={
                      x.name === "System Administrator" ? "user_role" : "user"
                    }
                  />
                ),
              },
            }));
          }

          var adminUserSel = response[0].userProfileList
            .filter(function (user) {
              return user.name === "System Administrator";
            })
            .map((x) => ({
              value: x.id,
              label: x.name,
              disabled: x.name === "System Administrator",
              type: x.name === "System Administrator" ? "user_role" : "user",
              ...{
                icon: (
                  <Icon
                    assistiveText={{ label: "Account" }}
                    category="standard"
                    name={
                      x.name === "System Administrator" ? "user_role" : "user"
                    }
                  />
                ),
              },
            }));
          this.setState({
            adminUser: adminUserSel,
            accountsWithIcon: usertypesWithIcon,
            CheckboxInputError: chkbxErr,
            selection: comboSelectionObj,
            inputValue: comboInputObj,
            packageAccessCtrl: response
          }, () => {
            this.setupAccessibilityHeaderCheckboxes();
            this.forceUpdate();
          });
        }
        this.setState({ isLoading: false });
      });
  };

  toggleAccessCtrlModalOpen = () => {
    this.setState({ isAccessCtrlModalOpen: !this.state.isAccessCtrlModalOpen });
  };

  savePackageAccessCtrl = () => {
    let inputError = false;
    inputError = this.updateCustomProfileSelection();

    // If there is validation error dont proceed.
    if (inputError) {
      this.forceUpdate();
      return;
    }
    let orgID = getOrgId();
    this.setState({ isLoading: true });

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getAccessToken(),
      },
      body: JSON.stringify(this.state.packageAccessCtrl),
    };

    api.post(
      getApiBaseURL() + "/CustomerPreference/SavePackageAccessControl/" + orgID,
      JSON.stringify(this.state.packageAccessCtrl),
      requestOptions
    )
      // .then(handleAPIErrors)
      .then((response) => response.data)
      .then((response) => {
        if (response) {
          this.toggleAccessCtrlModalOpen();
          this.setState({ isLoading: false });
          this.openToast("Access Control Settings Saved!");
        }
      });
  };

  openEarlyFeedbackModal = () => {
    this.toggleEarlyFeedbackModalOpen();
  };

  toggleEarlyFeedbackModalOpen = () => {
    this.setState({
      isEarlyFeedbackModalOpen: !this.state.isEarlyFeedbackModalOpen,
    });
  };

  navigateToEarlyFeedbackDashboard = () => {
    let orgID = getOrgId();
    this.setState({ isLoading: true });
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getAccessToken(),
      },
    };

    api.get(
      getApiBaseURL() + "/Login/GetEarlyFeedbackURL/" + orgID,
      requestOptions
    )
      // .then(handleAPIErrors)
      .then((response) => response.data)
      .then((response) => {
        logoutAndRedirectToURL(response);
      });
  };

  /* Method triggered to save Customer Preference/Register the Organization */
  saveCustomerPreference() {
    this.setState({ isLoading: true });
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getAccessToken(),
      },
      body: JSON.stringify(this.state.organization),
    };

    api.post(
      getApiBaseURL() + "/CustomerPreference/SaveCustomerPreference",
      JSON.stringify(this.state.organization),
      requestOptions
    )
      // .then(handleAPIErrors)
      .then((response) => response.data)
      .then((response) => {
        if (response) {
          this.setState({ isLoading: false, changeBtnTextToUpdate: true, disableUpdateBtn: true, organization: { ...this.state.organization, orgStatus: 'Active' } });
          this.openToast("Customer Preference Saved");

          if (isEmpty(this.state.organization.id) && this.state.organization.hasCLMCPQProduct) {
            this.openEarlyFeedbackModal();
          }
        }
      });
  }

  /* Method triggered to set the Header Toggle buttons */
  setupAccessibilityHeaderCheckboxes(onload = false) {
    var adminCheckAll = true;
    var allUserCheckAll = true;
    var customProfileCheckAll = true;
    this.state.packageAccessCtrl.forEach((pkg) => {
      switch (pkg.accessibility.toUpperCase()) {
        case AccessControlEnum.InstallForAdminOnly.toString().toUpperCase():
          allUserCheckAll = false;
          customProfileCheckAll = false;
          break;
        case AccessControlEnum.InstallForAllUsers.toString().toUpperCase():
          adminCheckAll = false;
          customProfileCheckAll = false;
          break;
        case AccessControlEnum.InstallForCustomProfiles.toString().toUpperCase():
          adminCheckAll = false;
          allUserCheckAll = false;
          break;
        default:
          adminCheckAll = false;
          allUserCheckAll = false;
          customProfileCheckAll = false;
          break;
      }
    });
    this.setState({ isHeadInstallForAdmin: adminCheckAll });
    this.setState({ isHeadInstallForAllUsers: allUserCheckAll });
    this.setState({ isHeadInstallForCustomProfiles: customProfileCheckAll });
  }

  /* Method to trigger when Select all header checkbox is triggered from Access Control Modal */
  onSelectAll(accessControl, event) {
    var pkgList = JSON.parse(JSON.stringify(this.state.packageAccessCtrl));
    this.setAdminUserbyDefault();
    pkgList.forEach((pkg) => {
      pkg.accessibility = accessControl;
      this.updateInputError(pkg.packageId, false);
    });
    this.setState({ packageAccessCtrl: pkgList });
    switch (accessControl.toUpperCase()) {
      case AccessControlEnum.InstallForAdminOnly.toString().toUpperCase():
        this.setState({ isHeadInstallForCustomProfiles: false });
        this.setState({ isHeadInstallForAllUsers: false });
        this.setState({ isHeadInstallForAdmin: true });
        break;
      case AccessControlEnum.InstallForAllUsers.toString().toUpperCase():
        this.setState({ isHeadInstallForAdmin: false });
        this.setState({ isHeadInstallForCustomProfiles: false });
        this.setState({ isHeadInstallForAllUsers: true });
        break;
      case AccessControlEnum.InstallForCustomProfiles.toString().toUpperCase():
        this.setState({ isHeadInstallForAdmin: false });
        this.setState({ isHeadInstallForAllUsers: false });
        this.setState({ isHeadInstallForCustomProfiles: true });

        break;
      default:
        this.setState({ isHeadInstallForAdmin: false });
        this.setState({ isHeadInstallForAllUsers: false });
        this.setState({ isHeadInstallForCustomProfiles: false });
        break;
    }
  }

  /* Method triggered to set Admin User Profile by default */
  setAdminUserbyDefault() {
    var destinationObject = Object.assign(this.state.selection);
    this.state.packageAccessCtrl.forEach((x) => {
      if (
        x.accessibility.toUpperCase() !==
        AccessControlEnum.InstallForCustomProfiles.toString().toUpperCase()
      )
        destinationObject[x.packageId] = this.state.adminUser;
    });

    this.setState({ selection: destinationObject });
  }

  /* Method triggered when package access checkbox is changed */
  getChckeboxValue(index, event) {
    const value = event.target.value;
    var newObject = JSON.parse(JSON.stringify(this.state.packageAccessCtrl));
    newObject[index].accessibility = value;
    this.setState(
      {
        packageAccessCtrl: newObject,
      },
      () => {
        this.setupAccessibilityHeaderCheckboxes();
      }
    );

    let pkgId = newObject[index].packageId;

    if (
      value.toUpperCase() ===
      AccessControlEnum.InstallForCustomProfiles.toString().toUpperCase()
    ) {
      var destinationObject = Object.assign(this.state.selection);
      destinationObject[pkgId] = this.state.adminUser;
      this.setState({ selection: destinationObject });
    } else {
      this.updateInputError(pkgId, false);
    }
  }

  /* Method triggered when Custom User Profile is changed */
  updateComboSelection(pkgId, selection) {
    var destinationObject = Object.assign(this.state.selection);
    const adminUserExists = selection.some(
      (user) => user.value === this.state.adminUser[0].value
    );
    if (!adminUserExists) {
      return;
    }
    destinationObject[pkgId] = [...new Set(selection)];

    var newInput = Object.assign(this.state.inputValue);
    newInput[pkgId] = "";
    this.setState({
      inputValue: newInput,
      selection: destinationObject,
    });
    if (this.state.selection[pkgId].length >= 1) {
      this.updateInputError(pkgId, false);
    } else {
      this.updateInputError(pkgId, true);
    }
    this.forceUpdate();
  }

  updateInputError(pkgId, value) {
    var obj = Object.assign(this.state.CheckboxInputError);
    obj[pkgId] = value;
    this.setState({ CheckboxInputError: obj });
  }

  /* Method triggered when to load Custom Profile into the packageAccessCtrl collection. This will be saved in DB */
  updateCustomProfileSelection() {
    let inputError = false;
    for (let i = 0; i < this.state.packageAccessCtrl.length; i++) {
      if (
        this.state.packageAccessCtrl[i].accessibility.toUpperCase() ===
        AccessControlEnum.InstallForCustomProfiles.toString().toUpperCase()
      ) {
        this.state.packageAccessCtrl[i].customProfileIds = this.state.selection[
          this.state.packageAccessCtrl[i].packageId
        ].map((item) => {
          return item.value;
        });

        if (this.state.packageAccessCtrl[i].customProfileIds.length < 1) {
          let pkgId = this.state.packageAccessCtrl[i].packageId;
          this.updateInputError(pkgId, true);
          inputError = true;
        }
      } else {
        this.state.packageAccessCtrl[i].customProfileIds = [];
      }
    }

    return inputError;
  }

  render() {
    return (
      <div>
        {this.state.isLoading && (
          <Spinner
            size="large"
            variant="brand"
            assistiveText={{ label: "Loading..." }}
          />
        )}
        <div class="reg-bg-theme">
          <IconSettings iconPath={SF_ICON_PATH}>
            {this.state.showToast && (
              <ToastContainer>
                <Toast
                  labels={{
                    heading: [this.state.toastHeaderInfo],
                  }}
                  variant="success"
                  duration="3000"
                  onRequestClose={() => {
                    this.setState({ showToast: false });
                  }}
                />
              </ToastContainer>
            )}
          </IconSettings>
          <div class="slds-context-bar">
            <div class="slds-context-bar__primary">
              <div class="slds-context-bar__item slds-context-bar__dropdown-trigger slds-dropdown-trigger slds-dropdown-trigger_click slds-no-hover">
                <div class="slds-context-bar__icon-action">
                  <img class="img" width="30" alt="Conga Logo" src={logo} />
                </div>
                <span class="slds-context-bar__label-action slds-context-bar__app-name">
                  <span class="slds-truncate" title="Conga Upgrade">
                    Conga Upgrade
                  </span>
                </span>
              </div>
            </div>
            <nav class="slds-context-bar__secondary" role="navigation">
              <ul class="slds-grid">
                <li
                  class="slds-context-bar__item slds-is-active"
                  routerLinkActive="slds-is-active"
                >
                  <a class="slds-context-bar__label-action" title="Home">
                    <span class="slds-truncate" title="Org Registration Form">
                      Org Registration Form
                    </span>
                  </a>
                </li>
                <li
                  class="slds-context-bar__item"
                  routerLinkActive="slds-is-active"
                >
                  <a
                    class="slds-context-bar__label-action"
                    title="Menu Item"
                    onClick={this.handleClick}
                  >
                    <span class="slds-truncate" title="Release Details">
                      Installed Release Details
                    </span>
                  </a>
                </li>
              </ul>
            </nav>
            <div className="logout-wrapper">
              <a class="logout-icon" onClick={logout}>
                <span title="Log Out">
                  <IconSettings iconPath={SF_ICON_PATH}>
                    <div className="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center">
                      <div className="slds-col_padded">
                        <Icon
                          assistiveText={{ label: "Account" }}
                          category="utility"
                          name="logout"
                          size="small"
                        />
                      </div>
                    </div>
                  </IconSettings>
                </span>
              </a>
            </div>
          </div>

          <div class="row reg-form slds-text-body_regular">
            <div class="col-md-12 rounded org-detail shadow-lg p-3 mb-5">
              <p class="consent-header">
                This consent will be used for the sole purpose of authorising
                <span class="label-brand"> Conga</span> to upgrade given org with
                the latest conga packages and install dependant packages if they
                are not available in the Org.
              </p>

              <hr class="solid" />
              <h2>Organization Details</h2>

              <div class="org-info-div">
                <div class="row">
                  <div class="col-3">Organization Name</div>
                  <div class="col-9">
                    <Input
                      assistiveText={{ label: "Org-Name" }}
                      id="Org-Name"
                      placeholder="Organization Name"
                      value={this.state.organization.organizationName}
                      disabled
                    />
                  </div>
                </div>
                <br></br>
                <div class="row">
                  <div class="col-3">Organization ID</div>
                  <div class="col-9">
                    <Input
                      assistiveText={{ label: "My label" }}
                      id="Org-id"
                      placeholder="Organization ID"
                      value={
                        this.state.organization.orgId
                          ? removeOrgIdCheksum(this.state.organization.orgId)
                          : null
                      }
                      disabled
                    />
                  </div>
                </div>
                <br></br>
                <div class="row">
                  <div class="col-3">Organization Edition</div>
                  <div class="col-9">
                    {" "}
                    <Input
                      assistiveText={{ label: "Org-Edition" }}
                      id="Org-Edition"
                      placeholder="Organization Edition"
                      value={this.state.organization.organizationType}
                      disabled
                    />
                  </div>
                </div>
                <br></br>
                <div class="row">
                  <div class="col-3">Environment</div>
                  <div class="col-9">
                    {" "}
                    <Input
                      assistiveText={{ label: "Environment" }}
                      id="Environment"
                      placeholder="Environment"
                      value={this.state.organization.isSandbox}
                      disabled
                    />
                  </div>
                </div>
                <br></br>
                <div class="row">
                  <div class="col-3">User Name</div>
                  <div class="col-9">
                    <Input
                      assistiveText={{ label: "User-Name" }}
                      id="User-Name"
                      placeholder="User Name"
                      value={this.state.organization.userName}
                      disabled
                    />
                  </div>
                </div>
                <br></br>
                <div class="row">
                  <div class="col-3">Email ID</div>
                  <div class="col-9">
                    {" "}
                    <Input
                      assistiveText={{ label: "Email-id" }}
                      id="Email-id"
                      placeholder="Email ID"
                      value={this.state.organization.emailId}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <br></br>
              <hr class="solid" />
              <div>
                <h2>Package Access</h2>
                <br />
                <div class="slds-grid slds-grid_pull-padded slds-grid_vertical-align-center">
                  <div class="slds-col_padded">
                    <span class="acc-text">
                      To set the accessibility for Conga packages which shall be
                      upgraded using Conga Upgrade Program
                    </span>
                    <br />
                    <br />
                    <div class="reg-btn">
                      <Button
                        label="Set Package Access"
                        variant="brand"
                        onClick={() => this.openAccessControlModal()}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <br />
              
              {this.state.organization.hasCLMCPQProduct && (
              <div class="disclaimer">
                <hr class="solid" />
                <h2>Early Feedback Program</h2>
                <p>
                  Now users have an option to get an early feedback by running
                  the test in existing version of our service in the registered
                  org.
                  <br />
                  <br />
                  Early feedback also allows Conga to enhance their "Golden Test
                  Suite" (These are some of the Out-Of-Box API based tests)
                  which will run once before and after the org. upgrade just to
                  catch any unexpected functionality changes between the
                  releases.
                  <br />
                  <br />
                </p>
                {this.state.changeBtnTextToUpdate ? (
                  <p>
                    To start "Early Feedback" program and see how the Golden
                    Test Suite runs in existing version{" "}
                    <a
                      href="JavaScript:void(0)"
                      onClick={this.navigateToEarlyFeedbackDashboard}
                    >
                      {" "}
                      click here
                    </a>
                  </p>
                ) : (
                  <span>
                    This feature works only after org registration. Please click
                    on "Submit" button to register your org.
                  </span>
                )}
              </div>
              )}

              
                <div class="disclaimer">
                  <br />
                  <hr class="solid" />
                  <h2>Add-Ons</h2>
                  <div className="slds-col_padded">
                    <Checkbox
                      size="large"
                      assistiveText={{
                        label: "Default",
                      }}
                      id="checkbox-autoupgradeforga"
                      checked={
                        this.state.organization
                          .enableAutoUpgradeForGA
                      }
                      labels={{
                        label:
                          "Allow Conga to auto-upgrade your org when new GA release is available.",
                      }}
                      onChange={(e) => {
                        console.log("onChange ", e.target);
                        this.setState({ disableUpdateBtn: false });

                        this.setState((prevState) => ({
                          organization: {
                            // object that we want to update
                            ...prevState.organization, // keep all other key-value pairs
                            enableAutoUpgradeForGA: !prevState
                              .organization
                              .enableAutoUpgradeForGA, // update the value of specific key
                          },
                        }));
                      }}
                    />
                  </div>
                  {/* PU-2012 Hiding the below div. The Requiremnt is not clear.*/}
                  {false && (
                  <div className="slds-col_padded">
                    <Checkbox
                      size="large"
                      assistiveText={{
                        label: "Default",
                      }}
                      id="checkbox-optoutfromnextgarelease"
                      checked={
                        this.state.organization
                          .optOutForNextGARelease
                      }
                      labels={{
                        label:
                          "Opt-out your org from auto upgrade only for next GA release.",
                      }}
                      onChange={(e) => {
                        console.log("onChange ", e.target);
                        this.setState({ disableUpdateBtn: false });

                        this.setState((prevState) => ({
                          organization: {
                            // object that we want to update
                            ...prevState.organization, // keep all other key-value pairs
                            optOutForNextGARelease: !prevState
                              .organization
                              .optOutForNextGARelease, // update the value of specific key
                          },
                        }));
                      }}
                    />
                  </div>
                  )}
                  {this.state.organization.isAdobePkgInstalled && (
                  <div className="slds-col_padded">
                    <Checkbox
                      size="large"
                      assistiveText={{
                        label: "Default",
                      }}
                      id="checkbox-example"
                      checked={
                        this.state.organization
                          .enableExternalDependentPackageInstallation
                      }
                      labels={{
                        label:
                          "Allow Conga to upgrade the Adobe Sign package to recommended version as per release notes",
                      }}
                      onChange={(e) => {
                        console.log("onChange ", e.target);
                        this.setState({ disableUpdateBtn: false });

                        this.setState((prevState) => ({
                          organization: {
                            // object that we want to update
                            ...prevState.organization, // keep all other key-value pairs
                            enableExternalDependentPackageInstallation: !prevState
                              .organization
                              .enableExternalDependentPackageInstallation, // update the value of specific key
                          },
                        }));
                      }}
                    />
                  </div>
                  )}
                </div>
              

              <br />
              <div class="label-red">
                {!isEmpty(this.state.organization.id) && this.state.organization.orgStatus !== "OptedOut" && (
                  <p>
                    ** For the given org{" "}
                    {removeOrgIdCheksum(this.state.organization.orgId)} the Push
                    Upgrade is set up by {this.state.organization.createdBy} on{" "}
                    {dateFormatter(this.state.organization.createdDate)}{" "}
                  </p>
                )}
                {!isEmpty(this.state.organization.id) && this.state.organization.orgStatus === "OptedOut" && (
                  <p>
                    ** For the given org{" "}
                    {removeOrgIdCheksum(this.state.organization.orgId)}  has been opted out of Conga Upgrade.
                  </p>
                )}
                <br />
                <br />
              </div>
              <div>
                <div class="reg-btn text-center">
                  <Button
                    variant="brand"
                    onClick={() => this.saveCustomerPreference()}
                    disabled={this.state.disableUpdateBtn && this.state.organization.orgStatus !== "OptedOut"}
                  >
                    {this.state.organization.orgStatus === "OptedOut" ? "Register Again" : (this.state.changeBtnTextToUpdate ? "Update" : "Submit")}
                  </Button>
                </div>
              </div>

              <br />
              <hr class="solid" />

              <div class="disclaimer">
                <h2>Notes</h2>
                <p>
                  To know more about each release or product, kindly refer to{" "}
                  <a href="https://documentation.conga.com">
                    https://documentation.conga.com
                  </a>
                  <br />
                  This package may send or release data from third-party
                  websites. Make sure you trust these websites -
                  <br /> CSP Trusted Site
                </p>
                <ul>
                  <li>https://content.analytics.apttus.com</li>
                  <li>https://data.analytics.apttus.com</li>
                  <li>Website - data.analytics.apttus.com(SSL Encrypted)</li>
                </ul>
              </div>
            </div>
          </div>
        </div >

        <IconSettings iconPath={SF_ICON_PATH}>
          <div>
            <Modal
              isOpen={this.state.isAccessCtrlModalOpen}
              footer={[
                this.state.displayDependentPkgFootnotes && (
                  <div class="footerLeft">
                    Packages with (*) are dependent packages which needs to be
                    installed to ensure the core features to work as expected
                  </div>
                ),
                <Button
                  label="Close"
                  onClick={this.toggleAccessCtrlModalOpen}
                />,
                <Button
                  label="Save"
                  variant="brand"
                  onClick={this.savePackageAccessCtrl}
                />,
              ]}
              onRequestClose={this.toggleAccessCtrlModalOpen}
              heading="Conga Package Access"
              size="medium"
            >
              <section className="slds-p-around_large">
                <div class="access-ctrl-tbl-div">
                  {this.state.packageAccessCtrl.length > 0 ? (
                    <table class="pkg-access-tbl table table-hover">
                      <thead>
                        <tr>
                          <th scope="col" class="cdk-column-packageName">
                            Package Name
                          </th>
                          <th
                            scope="col"
                            class="cdk-column-installForAdminOnly"
                          >
                            <div className="slds-col_padded">
                              <Checkbox
                                labels={{
                                  label: "Install For Admin Only",
                                  toggleEnabled: "All Selected",
                                  toggleDisabled: "Select All",
                                }}
                                id="checkbox-toggle-example1"
                                name="selectAll"
                                variant="toggle"
                                onChange={this.onSelectAll.bind(
                                  this,
                                  "InstallForAdminOnly"
                                )}
                                checked={this.state.isHeadInstallForAdmin}
                              />
                            </div>
                          </th>
                          <th scope="col" class="cdk-column-installForAllUsers">
                            <div className="slds-col_padded">
                              <Checkbox
                                labels={{
                                  label: "Install For All Users",
                                  toggleEnabled: "All Selected",
                                  toggleDisabled: "Select All",
                                }}
                                id="checkbox-toggle-example2"
                                name="selectAll"
                                variant="toggle"
                                onChange={this.onSelectAll.bind(
                                  this,
                                  "InstallForAllUsers"
                                )}
                                checked={this.state.isHeadInstallForAllUsers}
                              />
                            </div>
                          </th>
                          <th
                            scope="col"
                            class="cdk-column-installForSpecificProfiles"
                          >
                            <Tooltip
                              dialogClassName="pkg-custom-tooltip"
                              id="tooltip"
                              align="right"
                              content="Standard profiles (including the Read-Only profile) don't receive access to any installed custom objects. Because permissions are not editable for standard profiles, you must clone your profile to grant access. These security settings
                                determine access to the custom objects and components installed in the package. It doesn't affect permissions for existing objects."
                            >
                              <div className="slds-col_padded">
                                <Checkbox
                                  labels={{
                                    label: "Install For Specific Profiles",
                                    toggleEnabled: "All Selected",
                                    toggleDisabled: "Select All",
                                  }}
                                  id="checkbox-toggle-example3"
                                  name="selectAll"
                                  variant="toggle"
                                  onChange={this.onSelectAll.bind(
                                    this,
                                    "InstallForCustomProfiles"
                                  )}
                                  checked={
                                    this.state.isHeadInstallForCustomProfiles
                                  }
                                />
                              </div>
                            </Tooltip>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.packageAccessCtrl.map((pkg, index) => (
                          <tr>
                            <td>
                              {pkg.packageName} {!pkg.isInstalledPackage && "*"}
                              <br />{" "}
                              {this.state.CheckboxInputError[pkg.packageId] && (
                                <span class="profile-error-msg">
                                  *Please select user profile
                                </span>
                              )}
                            </td>
                            <td>
                              <input
                                type="radio"
                                name={pkg.packageId}
                                value="InstallForAdminOnly"
                                checked={
                                  "InstallForAdminOnly" === pkg.accessibility
                                }
                                onClick={this.getChckeboxValue.bind(
                                  this,
                                  index
                                )}
                              />
                            </td>
                            <td>
                              <input
                                type="radio"
                                name={pkg.packageId}
                                value="InstallForAllUsers"
                                checked={
                                  "InstallForAllUsers" === pkg.accessibility
                                }
                                onClick={this.getChckeboxValue.bind(
                                  this,
                                  index
                                )}
                              />
                            </td>
                            <td>
                              <input
                                type="radio"
                                name={pkg.packageId}
                                value="InstallForCustomProfiles"
                                checked={
                                  "InstallForCustomProfiles" ===
                                  pkg.accessibility
                                }
                                onClick={this.getChckeboxValue.bind(
                                  this,
                                  index
                                )}
                              />
                              {"InstallForCustomProfiles" ===
                                pkg.accessibility && (
                                  <Grid container alignItems="center" gap="10px" className="btn-clone-wrapper">
                                    <Grid item xs={index === 0 ? 9 : 12}>
                                      <Combobox
                                        id={"combobox-" + pkg.packageId}
                                        name={pkg.packageId}
                                        events={{
                                          onRequestRemoveSelectedOption: (
                                            event,
                                            data
                                          ) => {
                                            this.updateComboSelection(
                                              pkg.packageId,
                                              data.selection
                                            );
                                          },
                                          onSelect: (event, data) => {
                                            this.updateComboSelection(
                                              pkg.packageId,
                                              data.selection
                                            );
                                          },
                                          onChange: (event, { value }) => {
                                            console.log({ value, pkgId: pkg.packageId, inputValue: this.state.inputValue });
                                            this.setState(state => ({
                                              ...state,
                                              inputValue: {
                                                ...state.inputValue,
                                                [pkg.packageId]: value
                                              }
                                            }));
                                          },
                                        }}
                                        labels={{
                                          label:
                                            "Which profiles do you prefer to give full access?",
                                          placeholder:
                                            "Select Any Profiles",
                                        }}
                                        multiple
                                        menuItemVisibleLength={5}
                                        options={
                                          comboboxFilterAndLimit({
                                            inputValue: this.state.inputValue[pkg.packageId],
                                            limit: 1000,
                                            options: this.state.accountsWithIcon[pkg.packageId],
                                            selection: this.state.selection[pkg.packageId],
                                          })
                                        }
                                        selection={this.state.selection[pkg.packageId]}
                                        value={this.state.inputValue[pkg.packageId]}
                                      />
                                    </Grid>
                                    {
                                      index === 0 &&
                                      <Tooltip triggerClassName="btn-clone" align="right" content="Apply the selected profile for all the below packages">

                                        <div
                                          style={{
                                            backgroundColor: '#16325c',
                                            padding: '5px',
                                            display: 'inline-block',
                                            borderRadius: '5px'
                                          }}
                                          className="-m-horizontal--small"
                                        >
                                          <Button
                                            iconCategory="action"
                                            iconName="clone"
                                            iconSize="large"
                                            inverse
                                            variant="icon"
                                            onClick={() => {
                                              if (this.state && this.state.packageAccessCtrl) {
                                                let destinationObject = Object.assign(this.state.selection);
                                                this.state.packageAccessCtrl.forEach(item => {
                                                  if (item.accessibility === "InstallForCustomProfiles") {
                                                    destinationObject[item.packageId] = [...new Set(destinationObject[pkg.packageId])];
                                                  }
                                                });
                                                this.setState(state => ({
                                                  ...state,
                                                  selection: destinationObject,
                                                }));
                                                this.forceUpdate();
                                              }
                                            }}
                                          />
                                        </div>
                                      </Tooltip>
                                    }
                                  </Grid>
                                )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div>No Packages found</div>
                  )}
                </div>
              </section>
            </Modal>

            <Modal
              isOpen={this.state.isEarlyFeedbackModalOpen}
              footer={[
                <Button
                  label="Close"
                  onClick={this.toggleEarlyFeedbackModalOpen}
                />,
                <Button
                  label="Try Now"
                  variant="brand"
                  onClick={this.navigateToEarlyFeedbackDashboard}
                />,
              ]}
              onRequestClose={this.toggleEarlyFeedbackModalOpen}
              heading="Conga Package Access"
              size="small"
            >
              <section className="slds-p-around_large">
                <div class="slds-p-around_medium">
                  Your Org is registered succesfully!
                  <br /> Do you wish to run the Early Feedback program with the
                  existing version of Conga services in the registered Org ?
                </div>
              </section>
            </Modal>
          </div>
        </IconSettings >
      </div >
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Registration));
